(function () {
  if (window.__ebkCartInit) return;
  window.__ebkCartInit = true;

  // Panier tiroir maison (sections/ebk-cart-drawer.liquid). Le contenu est
  // toujours rendu par Shopify en Liquid : ce script ne fait que redemander la
  // section apres chaque changement du panier et remplacer le contenu.
  //
  // Site-wide : on detecte TOUT changement du panier, peu importe le script qui
  // le fait (boutons d'achat du theme, ajout rapide, offre de volume, landing,
  // systeme de bonus, apps tierces), en surveillant les appels reseau vers
  // /cart/add, /cart/change, /cart/update et /cart/clear. Un ajout reussi ouvre
  // le tiroir ; les autres changements le rafraichissent seulement.

  var SECTION = 'ebk-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  var refreshTimer = null;
  var requestSeq = 0;
  var lastFocus = null;
  var noteTimer = null;

  function drawer() { return document.getElementById('EbkCart'); }
  function body() { var d = drawer(); return d && d.querySelector('[data-ebk-cart-body]'); }

  // Sur la page /cart, la page elle-meme est le panier : pas d'ouverture
  // automatique par-dessus (le clic sur l'icone ouvre quand meme le tiroir).
  function isCartPage() { return document.body.classList.contains('template-cart'); }

  // ---------- Ouverture / fermeture ----------

  function open() {
    var d = drawer();
    if (!d || d.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ebk-cart-open');
    var panel = d.querySelector('.ebk-cart__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ebk-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // ---------- Rendu ----------

  function applySection(html) {
    var current = body();
    if (!current || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-ebk-cart-body]');
    if (!fresh) return;

    // Garde l'etat de ce que le client est en train de faire : note ouverte
    // (et son texte s'il tape encore), position de defilement.
    var noteOpen = current.querySelector('[data-ebk-cart-note]:not([hidden])');
    var noteValue = noteOpen ? noteOpen.value : null;
    var scroller = current.querySelector('.ebk-cart__scroll');
    var scrollTop = scroller ? scroller.scrollTop : 0;

    current.innerHTML = fresh.innerHTML;
    current.dataset.count = fresh.dataset.count;

    if (noteOpen) {
      var note = current.querySelector('[data-ebk-cart-note]');
      var toggle = current.querySelector('[data-ebk-cart-note-toggle]');
      if (note) { note.hidden = false; note.value = noteValue; }
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    var newScroller = current.querySelector('.ebk-cart__scroll');
    if (newScroller) newScroller.scrollTop = scrollTop;

    updateBubbles(parseInt(fresh.dataset.count, 10) || 0);
  }

  // Pastille du nombre d'articles sur l'icone panier du header (markup du theme).
  function updateBubbles(count) {
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function refresh() {
    var seq = ++requestSeq;
    return originalFetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // Une reponse plus recente a deja ete demandee : on ignore celle-ci.
        if (seq === requestSeq) applySection(data[SECTION]);
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 120);
  }

  // ---------- Actions dans le tiroir ----------

  function setBusy(isBusy) {
    var b = body();
    if (b) b.classList.toggle('is-busy', isBusy);
  }

  function changeQuantity(key, quantity) {
    var seq = ++requestSeq;
    setBusy(true);
    // Passe par window.fetch (pas originalFetch) pour que le systeme de bonus
    // de theme.liquid voie ce changement et ajuste les cadeaux.
    return window.fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: quantity, sections: [SECTION], sections_url: window.location.pathname }),
      __ebkCart: true
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status && data.description) {
          alert(data.description);
          return refresh();
        }
        if (seq === requestSeq && data.sections) applySection(data.sections[SECTION]);
      })
      .catch(function () { return refresh(); })
      .finally(function () { setBusy(false); });
  }

  function addVariant(variantId, btn) {
    if (btn) btn.disabled = true;
    return window.fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: String(variantId), quantity: 1 }], sections: [SECTION], sections_url: window.location.pathname }),
      __ebkCart: true,
      __volumeOfferBypass: true // evite que le patch fetch de volume-offer.js ne reecrive cet appel
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status && data.description) {
          alert(data.description);
          if (btn) btn.disabled = false;
          return;
        }
        if (data.sections) applySection(data.sections[SECTION]);
        else refresh();
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }

  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      window.fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value }),
        __ebkCart: true,
        __cartGuardBypass: true
      }).catch(function () {});
    }, 400);
  }

  document.addEventListener('click', function (e) {
    // Icone panier du header (et tout lien marque data-ebk-cart-open) : capture,
    // pour passer avant le panier natif du theme et ne pas suivre le lien /cart.
    var trigger = e.target.closest('#HeaderCartTrigger, [data-ebk-cart-open]');
    if (trigger && drawer()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      scheduleRefresh();
      return;
    }

    var d = drawer();
    if (!d || !d.contains(e.target)) return;

    if (e.target.closest('[data-ebk-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var qtyBtn = e.target.closest('[data-ebk-cart-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('[data-key]');
      if (item) changeQuantity(item.dataset.key, Math.max(0, parseInt(qtyBtn.dataset.ebkCartQty, 10) || 0));
      return;
    }

    var addBtn = e.target.closest('[data-ebk-cart-add]');
    if (addBtn && !addBtn.disabled) {
      addVariant(addBtn.dataset.ebkCartAdd, addBtn);
      return;
    }

    var noteToggle = e.target.closest('[data-ebk-cart-note-toggle]');
    if (noteToggle) {
      var note = d.querySelector('[data-ebk-cart-note]');
      if (!note) return;
      note.hidden = !note.hidden;
      noteToggle.setAttribute('aria-expanded', String(!note.hidden));
      if (!note.hidden) note.focus();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('#EbkCart [data-ebk-cart-qty-input]');
    if (!input) return;
    var item = input.closest('[data-key]');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (item) changeQuantity(item.dataset.key, qty);
  });

  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('#EbkCart [data-ebk-cart-note]');
    if (note) saveNote(note.value);
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') close();
  });

  // ---------- Detection des changements du panier (tous les scripts) ----------

  function onCartRequestDone(url, ok, isOurs) {
    if (!ok || isOurs) return;
    if (ADD_RE.test(url) && !isCartPage()) {
      // Contenu a jour d'abord, puis ouverture : le client ne voit pas
      // l'ancien panier glisser a l'ecran.
      clearTimeout(refreshTimer);
      refresh().then(open);
      return;
    }
    scheduleRefresh();
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(window, arguments);
    if (CART_RE.test(url)) {
      var isOurs = !!(init && init.__ebkCart);
      result.then(function (res) { onCartRequestDone(url, res && res.ok, isOurs); }).catch(function () {});
    }
    return result;
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ebkCartUrl = CART_RE.test(String(url)) ? String(url) : null;
    return originalOpen.apply(this, arguments);
  };
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__ebkCartUrl) {
      xhr.addEventListener('loadend', function () {
        onCartRequestDone(xhr.__ebkCartUrl, xhr.status >= 200 && xhr.status < 300, false);
      });
    }
    return originalSend.apply(this, arguments);
  };

  // Signaux du theme et de nos scripts maison (systeme de bonus, cross-sell,
  // offre de volume) : rafraichir seulement. L'ouverture vient de la detection
  // d'un ajout ci-dessus, pour ne jamais ouvrir le tiroir tout seul quand le
  // systeme de bonus ajuste un cadeau au chargement de la page.
  document.addEventListener('ajaxProduct:added', scheduleRefresh);
  document.addEventListener('cart:open', function () { open(); scheduleRefresh(); });
  document.addEventListener('cart:close', close);

  // Retour arriere du navigateur (page servie depuis le cache) : panier peut-etre perime.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
